module.exports = __webpack_public_path__ + "static/media/Client2xs.0fed11c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeOperation/Client2xs.png
// module id = 525
// module chunks = 0